import ApiService from "../../services/api.service";

const HistoryService = {

	getHistoryItem(itemId, data) {
		return ApiService.post(`/history/item/${itemId}`, data)
	},

	getHistoryDoc(docId) {
		return ApiService.get(`/history/doc/${docId}`)
	}

}

export default HistoryService
